import icon from '@/presentation/assets/images/icons/tool-fto.svg';
import { AiAgentEnvService } from '@telecom/shared/services/ai-agent-env-service/ai-agent-env-service';
import type { CustomQueryParams } from '@/services/router-proxy/types';
import { type Manifest, type RouterConfig, type ToolConfig, PAGE_TYPE } from '@/types/manifest.ts';
import { FTO_REPORT_ROUTER_NAME } from '@/domains/fto-report/constants';
import { injectService } from '@patsnap/tahiti-core';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.TOOL,
    name: FTO_REPORT_ROUTER_NAME,
    exclusiveRoutePath: '/fto-report',
    getComponent: () => {
        const aiAgentEnvService = injectService<AiAgentEnvService>(AiAgentEnvService);
        if (aiAgentEnvService.isInAiAgentFlow) {
            return import('./FtoReportInAgent.vue');
        }
        return import('./FtoReport.vue');
    },
};


const toolConfig: ToolConfig = {
    tabIndex: 1,
    label: 'drafting.fto',
    icon,
    // todo: 需要修改,等后端提供
    aclCheckPath: (permission) => permission.ftoReport,
};

export const manifest: Manifest = {
    ...routerConfig,
    ...toolConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到 Novelty Check Report 页面
         * @param commandId - 命令(去到 Novelty Check Report 页面)
         * @param params - 参数(包含任务 ID)
         */
        executeCommand(commandId: 'command:route:novelty-check-report', params?: CustomQueryParams): void;
        /**
         * 去到 Novelty Check Report 页面(新窗口打开)
         * @param commandId - 命令(去到 Novelty Check Report 页面(新窗口打开))
         * @param taskId - 任务 ID, 如果未提供，即创建新任务
         */
        executeCommand(commandId: 'command:route:novelty-check-report:new-tab', taskId?: string): void;
    }
}
